import _store from "store2";
import {getCurrentTeamData, getTeamAllData} from "@/api/home";
import {ElMessage} from "element-plus";
import {objToArrays} from "@/utils/objToArrays";
import sessionStore from "@/utils/sessionStore";

const countshow = {
        namespaced: true,
        state: {
            myEmailList: [],
            allEmailList: JSON.parse(window.localStorage.getItem('sumData')) || [],
            getEmailListFlag: 0,
            sidebarTargetNumber: 0,
            sidbarNumbers: 0,
            teamSumDataLoading: false,
            teamSumDataLoadedTeamId: '',
        },
        mutations: {
            setEmailListFlag(state, payload) {
                state.getEmailListFlag = payload;
            },
            setSidebarTargetNumber(state, payload) {
                state.sidebarTargetNumber = payload
            },
            setSidbarNumbers(state, payload) {
                state.sidbarNumbers = payload;

            },
            setTeamSumDataLoading(state, payload) {
                state.teamSumDataLoading = !!payload
            },
            setTeamSumDataLoadedTeamId(state, payload) {
                state.teamSumDataLoadedTeamId = payload == null ? '' : String(payload)
            }
        },
        actions: {
            async getTeamAllDataApis({state, commit}, payload = {}) {
                const teamId = payload?.teamId || sessionStore.get('teamId')
                if (!teamId) return

                const res = await getCurrentTeamData({
                    teamId: teamId,
                })
                if (res?.code !== 200) {
                    ElMessage.error(res?.message)
                    return
                }
                const formatData = objToArrays(res?.result || {})
                state.myEmailList = formatData
            }
            ,
            async getTeamSumDataApis({state, commit}, payload = {}) {
                const teamId = payload?.teamId || sessionStore.get('teamId')
                if (!teamId) return

                commit('setTeamSumDataLoading', true)
                try {
                    const res = await getTeamAllData({
                        teamId: teamId,
                    })
                    if (res?.code !== 200) {
                        ElMessage.error(res?.message)
                        return;
                    }
                    const formatData = objToArrays(res?.result || {})
                    sessionStore.set('sumData', formatData)
                    try {
                        window.localStorage.setItem('sumData', JSON.stringify(formatData))
                    } catch (e) {
                    }
                    state.allEmailList = formatData;
                    commit('setTeamSumDataLoadedTeamId', teamId)
                } finally {
                    commit('setTeamSumDataLoading', false)
                }
            }
        },
    }
;

export default countshow;
